import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {Formik, Form, FormikValues, FormikProps} from 'formik'
import BuilderForm, {ToArray, checkChildren} from './BuilderForm'
import {SubmitForm} from './SubmitForm'
import { useHistory } from "react-router-dom";
import * as Yup from 'yup'
import * as _ from 'lodash'

interface FormConfig {
    items: any
    user: number
    nid: string
    type: string
    destination: string
    form_name: string
    title_form: string
    state_modal?: any
    success_message?: string
};

const FormBase: React.FC<FormConfig> = (props) => {
    const stepperRef = useRef<HTMLDivElement | null>(null)
    //const stepper = useRef<StepperComponent | null>(null)
    
    const [submitId, setSubmitId] = useState(false)
    

    let schemaObject: any = {};
    var initValues : any = {};
	let history = useHistory();
    
    const getValidationRule = (formField : any) => {
        let fieldValidationRule = '';
        fieldValidationRule = dataTypeValidation(formField.type, fieldValidationRule);
        fieldValidationRule = requiredValidation(formField.required, fieldValidationRule);
        return fieldValidationRule;
    };

    const dataTypeValidation = (fieldType : string, validationRule : any) => {
        let typeValidation = validationRule;
        switch(fieldType){
            case 'float':
                typeValidation = Yup.number().positive()
                break;
            case 'date':
                typeValidation = Yup.date().max(new Date());
                break;
            default:
                typeValidation = Yup.string();
        }
        return typeValidation;
    };

    const requiredValidation = (fieldRequired: boolean, validationRule: any) => {
        let requireValidation = _.cloneDeep(validationRule);
        if(fieldRequired){
            return requireValidation.required("Cannot be blank");
        }
        else{
            return requireValidation;
        }
    };

    const setInitValues = (currentField : any, delta: number) =>{
        if(typeof currentField !== 'undefined' ){
            let cleanedInitValue: any
            cleanedInitValue = currentField.value;
            if(currentField.value &&  !Array.isArray(currentField.value) && typeof currentField.value != 'object'){
                cleanedInitValue = currentField.value;
            }
            else if(currentField.value && currentField.value.fids){
                //console.log(currentField)
                cleanedInitValue = [currentField.value.fids]
            }
            else if(currentField.value && Array.isArray(currentField.value)){
                cleanedInitValue = currentField.value[0];
            }
            else if(typeof currentField.value === 'object' && !Array.isArray(currentField.value) && currentField.value !== null){
                cleanedInitValue = Object.values(currentField.value)[0];
            }
            else{
                cleanedInitValue = '';
            }

            if(currentField.name && currentField.parent_name){
                if(typeof initValues[currentField.parent_name] === 'undefined'){
                    initValues[currentField.parent_name] = {}
                }
                if(typeof initValues[currentField.parent_name][delta] === 'undefined'){
                    initValues[currentField.parent_name][delta] = {}
                }
                initValues[currentField.parent_name][delta][currentField.name] = cleanedInitValue;
            }
            else{
                initValues[currentField.name] = cleanedInitValue;
            }

            schemaObject[currentField.name] = getValidationRule(currentField)
        }
    }
    //console.log('FORM WINDOW FIELDS',window.FormSettings[props.form_name])
    Object.values(window.FormSettings[props.form_name][props.items].children).forEach((item: any) => {
        Object.values(window.FormSettings[props.form_name][item].children).forEach((field: any) => {
            const currentField = window.FormSettings[props.form_name][field]
            if(currentField.subform){
                Object.values(currentField.subform).forEach((field_delta: any, delta:number)=>{
                    Object.values(field_delta.structure).forEach((subgroup: any, k) => {
                        Object.values(subgroup.children).forEach((subfield: any, i) => {
                            setInitValues(window.FormSettings[props.form_name][subfield], delta)
                        })
                    })
                })
            }
            else{
                setInitValues(currentField, 0)
            }

        })
    })

    // console.log('INIT VALUES FORMIK',initValues)

    const schemaForm :any = Yup.object().shape(schemaObject)
    const [currentSchema, setCurrentSchema] = useState(schemaForm)

    /*const loadStepper = () => {
        stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
    }*/


    const submitForm = (values: any, actions: FormikValues) => {
        
        SubmitForm(values, props.type, props.user, props.form_name, props.nid!, setSubmitId)
        
        //CLOSE MODAL
        if(props.state_modal){
            props.state_modal(false)
        }
        
        if(props.success_message){
			localStorage.setItem("message", props.success_message)
		}else{
			localStorage.setItem("message", "Your modifications have been saved")
		}
  
        
	    setTimeout(()=>{
		    if(props.destination != "#"){
	        	history.push(props.destination)
	        }else{
		        window.scrollTo(0, 0)
	        }
	    },200)
    }

    useEffect(() => {
        
    }, [])

    const parent = window.FormSettings[props.form_name][props.items]
    
    
    //REDIRECT DUBMIT
    if(submitId){
	    
	    var type = props.type;
	    
	    if(type === 'researcher'){
		    type = 'profile'
	    }
	    
	    //REDIRECT EDIT
	    window.location.href = '/'+type+'/edit/' + submitId
	    
    }
    
    const form_name = props.form_name  
    const title_form = props.title_form   
    const state_modal = props.state_modal   
    
   // console.log("state_modal", state_modal)

    return(
        <Formik enableReinitialize={true} validationSchema={currentSchema} initialValues={initValues} onSubmit={submitForm}>
            {(props: FormikProps<any>) => (
                <div
                    ref={stepperRef}
                    className='stepper stepper-pills stepper-column border border-2 bg-white border-primary rounded  d-flex flex-column flex-column  mt-5'
                    id='kt_create_account_stepper'
                >

                    <h3 className='px-9 pt-9 pb-5'>{title_form}</h3>
                    <div className='d-flex flex-row-fluid flex-center bg-white rounded'>
                        <Form className='pb-10 w-100 w-xl-700px px-9' noValidate id='kt_create_account_form'>
                            {ToArray(parent.children).map((child,index) => (
                                checkChildren(window.FormSettings[form_name][child], props, form_name) && (
                                    <div id={window.FormSettings[form_name][child].title.toLowerCase()} key={index}
                                         className={index === 0 ? 'current' : ''}
                                         data-kt-stepper-element='content'>
                                        <div className='w-100'>
                                            <BuilderForm items={[child.toString()]} formikProps={props} form_name={form_name} state_modal={state_modal}
                                                         showGroupLabel></BuilderForm>
                                        </div>
                                    </div>
                                )
                            ))}

							{window.FormSettings[form_name].nosubmit !== 1 && (
	                            <div className='d-flex flex-stack pt-10'>
	                                <div>
	                                    <button type='submit' className='btn btn-lg btn-primary me-3' onClick={()=>{
                                            //if(state_modal){
	                                        //    state_modal(false)
                                            //}
                                        }}>
	                                        <span className='indicator-label'>
	                                            {'Submit'}
	                                            <KTSVG
	                                                path='/media/icons/duotune/arrows/arr064.svg'
	                                                className='svg-icon-3 ms-2 me-0'
	                                            />
	                                        </span>
	                                    </button>
	                                </div>
	                            </div>
                            )}
                        </Form>
                    </div>
                </div>
            )}
        </Formik>
    )
}
export {FormBase}
